<template>
  <div class="property-contents-container">
    <ModelAppearanceTabs v-model:tab="currentTab" :component-width="componentWidth"></ModelAppearanceTabs>
    <v-window v-model="currentTab" style="height: 100%" transition="none" reverse-transition="none">
      <!-- MODEL -->
      <v-window-item value="model">
        <state-model-properties :model="model" @notify-change="emitChange"></state-model-properties>
      </v-window-item>

      <!-- APPEARANCE -->
      <v-window-item value="appearance">
        <state-appearance-properties :model="model" @notify-change="emitChange"></state-appearance-properties>
      </v-window-item>
    </v-window>
  </div>
</template>

<script setup lang="ts">
import { State } from "../mvc/state";
import { computed } from "vue";
import ModelAppearanceTabs from "./ModelAppearanceTabs.vue";
import StateModelProperties from "./StateModelProperties.vue";
import StateAppearanceProperties from "./StateAppearanceProperties.vue";

const compProps = defineProps<{
  model: State;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tab: any;
  componentWidth: number;
}>();

const emit = defineEmits(["notifyChange", "update:tab"]);

function emitChange(model) {
  emit("notifyChange", model);
}

const currentTab = computed({
  get() {
    return compProps.tab;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set(tab: any) {
    emit("update:tab", tab);
  },
});
</script>

